<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Form ref="Forms" :model="Forms" :rules="Rules" label-position="top">
                <Divider orientation="left" class="text-primary">支出信息</Divider>
                <Row :gutter="32">
                    <Col span="24">
                        <FormItem label="零星项目" prop="small_project_id">
                            <Select v-model="Forms.small_project_id" :disabled="is_select" clearable filterable placeholder="零星项目" @on-change="projectChange">
                                <Option v-for="(item,index) in projectList" :key="index" :value="item.small_project_id">{{item.customer_name ? item.name + '（' + item.customer_name + '）' : item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="关联维保记录" prop="maintain_id">
                            <Select v-model="Forms.maintain_id" clearable filterable placeholder="关联维保记录(必选)" class="width-100" @on-change="maintainChange">
                                <Option v-for="(item,index) in maintainList" :key="index" :value="item.maintain_id">{{item.title}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="关联采购信息" prop="small_buyer_id">
                            <Select v-model="Forms.small_buyer_id" :disabled="!Forms.maintain_id" clearable filterable placeholder="关联采购信息(必选)" class="width-100" @on-change="buyerChange">
                                <Option v-for="(item,index) in buyerList" :key="index" :value="item.buyer_id">{{item.title}}{{item.company ? '（'+item.company+'）' : ''}} / {{item.pay_money}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="支出类型" prop="type_id">
                            <Select v-model="Forms.type_id" clearable filterable placeholder="支出类型" class="width-100">
                                <Option v-for="(item,index) in typeList" :key="index" :value="item.id">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="供应商" prop="company_id" :rules="[{ required: true, type: 'number',  message: '请选择供应商', trigger: 'change',  transform(value) { return parseInt(value)}}]">
                            <Select v-model="Forms.company_id" clearable filterable placeholder="选择供应商" class="width-100">
                                <Option v-for="(item,index) in companyList" :key="index" :value="item.company_id">{{item.company}}</Option>
                            </Select>
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="不含税金额" prop="money">
                            <Input v-model="Forms.money" type="number" clearable placeholder="如：10000" @on-blur="onNoTaxMoneyBlur" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="费率" prop="tax_rate">
                            <Input v-model="Forms.tax_rate" type="number" clearable placeholder="0~100" @on-blur="calcTaxMoney" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="税费" prop="tax_money">
                            <Input v-model="Forms.tax_money" type="number" clearable placeholder="" @on-blur="onTaxMoneyBlur" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="含税金额" prop="true_money">
                            <Input v-model="Forms.true_money" type="number" clearable placeholder="" @on-blur="onTrueMoneyBlur" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="附件" prop="image">
                            <Input v-model="Forms.image[0]" disabled>
                                <template #append>
                                    <div class="f-center">
                                        <Upload
                                            :show-upload-list="false"
                                            :action="upload_url"
                                            :headers = "{'token': $store.state.token}"
                                            :format="['xls','xlsx','rar','zip','doc','docx','txt','jpg','jpeg','png','pdf']"
                                            :max-size="50 * 1024"
                                            :on-success="handleSuccess"
                                            :on-format-error="handleFormatError"
                                            :on-exceeded-size="handleMaxSize">
                                            <a href="javascript:void(0);" class="text-primary"><Icon type="md-cloud-upload" />上传</a>
                                        </Upload>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDelete('image')" class="text-danger"><Icon type="md-trash" />删除</a>
                                        <Divider type="vertical" />
                                        <a href="javascript:void(0);" @click="FileDownload(Forms.image[0])" class="text-violet"><Icon type="md-download" />下载</a>
                                    </div>
                                </template>
                            </Input>
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="支出说明" prop="content">
                            <Input v-model="Forms.content" type="textarea" :rows="4" clearable placeholder="请输入支出说明" />
                        </FormItem>
                    </Col>
                </Row>
                <Divider orientation="left" class="text-primary">收款账户</Divider>
                <Row :gutter="32">
                    <Col span="12">
                        <FormItem label="收款账户" prop="pay_bank_account">
                            <Input v-model="Forms.pay_bank_account" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="账户实名" prop="pay_bank_real_name">
                            <Input v-model="Forms.pay_bank_real_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户银行" prop="pay_bank_name">
                            <Input v-model="Forms.pay_bank_name" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="12">
                        <FormItem label="开户地址" prop="pay_bank_address">
                            <Input v-model="Forms.pay_bank_address" clearable placeholder="" />
                        </FormItem>
                    </Col>
                    <Col span="24">
                        <FormItem label="备注信息" prop="remark">
                            <Input v-model="Forms.remark" type="textarea" :rows="4" clearable placeholder="备注信息" />
                        </FormItem>
                    </Col>
                </Row>
            </Form>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">取消</Button>
                <Button type="primary" :loading="$store.state.loading" @click="FormSubmit()">保存</Button>
            </div>
        </div>
    </Drawer>
</template>

<script>

import {getDispersedExpendConfig, getDispersedExpendDetail, getMaintainSearchList, getSmallBuyerSearchList, saveDispersedExpend} from "@/apis/dispersed";

export default {
    name: 'DispersedExpendCreate',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '零星项目支出',
            isBox : false,
            typeList: [],
            companyList: [],
            projectList: [],
            maintainList: [],
            buyerList: [],
            is_select: false,
            lastMoneyInput: 'money',

            upload_url : this.$uploadFileApi,
            site_url : this.$siteApi,

            Forms : {
                expend_id: '',
                small_project_id: '',
                maintain_id: '',
                small_buyer_id: '',
                type_id: '',
                company_id: '',
                money: '',
                tax_rate: '',
                tax_money: '',
                true_money: '',
                image: [],
                content: '',
                pay_bank_account: '',
                pay_bank_real_name: '',
                pay_bank_name: '',
                pay_bank_address: '',
                remark: ''
            },
            Rules : {
                small_project_id: [
                    { required: true, type: 'number',  message: '请选择零星项目', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                maintain_id: [
                    { required: true, type: 'number',  message: '请选择维保记录', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                small_buyer_id: [
                    { required: true, type: 'number',  message: '请选择关联采购信息', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                type_id: [
                    { required: true, type: 'number',  message: '请选择支出类型', trigger: 'change',  transform(value) { return parseInt(value)}  }
                ],
                money: [
                    { required: true, type: 'number',  message: '请输入不含税金额', trigger: 'blur',  transform(value) { return parseFloat(value)} }
                ],
                pay_bank_account: [
                    { required: true, message: '请输入收款账户', trigger: 'blur'}
                ],
                pay_bank_real_name: [
                    { required: true, message: '请输入收款账户开户实名', trigger: 'blur'}
                ],
                content: [
                    { required: true, message: '请输入支出说明', trigger: 'blur'}
                ]
            }
        }
    },
    methods: {
        /**
         功能：不含税金额失焦，正算含税金额
         time: 2026/09/13
         **/
        onNoTaxMoneyBlur(){
            this.lastMoneyInput = 'money';
            this.calcTrueMoney();
        },
        /**
         功能：税费失焦，正算含税金额
         time: 2026/09/13
         **/
        onTaxMoneyBlur(){
            this.lastMoneyInput = 'money';
            this.calcTrueMoney();
        },
        /**
         功能：含税金额失焦，反算不含税金额和税费
         time: 2026/09/13
         **/
        onTrueMoneyBlur(){
            this.lastMoneyInput = 'true_money';
            this.calcMoney();
        },
        /**
         功能：费率失焦，按最后录入方向联动
         time: 2026/09/13
         **/
        calcTaxMoney(){
            let that = this;
            if(that.lastMoneyInput === 'true_money' && that.Forms.true_money !== ''){
                that.calcMoney();
                return;
            }
            let money = isNaN(parseFloat(that.Forms.money)) ? 0 : parseFloat(that.Forms.money);
            let tax_rate = isNaN(parseFloat(that.Forms.tax_rate)) ? 0 : parseFloat(that.Forms.tax_rate);
            that.Forms.tax_money = parseFloat(money) * parseFloat(tax_rate) / 100;
            that.calcTrueMoney();
        },
        /**
         功能：不含税金额 + 税费 正算含税金额
         time: 2026/09/13
         **/
        calcTrueMoney(){
            let that = this;
            let money = isNaN(parseFloat(that.Forms.money)) ? 0 : parseFloat(that.Forms.money);
            let tax_money = isNaN(parseFloat(that.Forms.tax_money)) ? 0 : parseFloat(that.Forms.tax_money);
            that.Forms.true_money = parseFloat(money) + parseFloat(tax_money);
        },
        /**
         功能：含税金额 + 费率 反算不含税金额和税费
         time: 2026/09/13
         **/
        calcMoney(){
            let that = this;
            let true_money = isNaN(parseFloat(that.Forms.true_money)) ? 0 : parseFloat(that.Forms.true_money);
            let tax_rate = isNaN(parseFloat(that.Forms.tax_rate)) ? 0 : parseFloat(that.Forms.tax_rate);
            if(tax_rate <= 0){
                that.Forms.tax_money = 0;
                that.Forms.money = parseFloat(true_money);
            }else{
                let money = (parseFloat(true_money) / (parseFloat(tax_rate) / 100 + 1)).toFixed(2);
                that.Forms.tax_money = (parseFloat(money) * parseFloat(tax_rate) / 100).toFixed(2);
                that.Forms.money = (parseFloat(true_money) - parseFloat(that.Forms.tax_money)).toFixed(2);
            }
        },
        /**
         功能：项目手动切换（清空已选维保记录）
         time: 2026/09/13
         **/
        projectChange(){
            let that = this;
            that.Forms.maintain_id = '';
            that.Forms.small_buyer_id = '';
            that.buyerList = [];
            that.changeProject();
        },
        /**
         * 功能：加载项目下维保记录（采购列表改由维保记录联动）
         * time: 2026/09/12
         **/
        changeProject(){
            let that = this;
            if(!that.Forms.small_project_id){
                that.maintainList = [];
                return;
            }
            getMaintainSearchList({small_project_id: that.Forms.small_project_id}).then(e=>{
                that.maintainList = e.data ?? [];
            })
        },
        /**
         * 功能：维保记录切换，重置并按维保记录联动加载已通过采购
         * time: 2026/10/06
         **/
        maintainChange(){
            let that = this;
            //维保变更后，原采购必然失效，先清空已选及回填的供应商账户
            that.Forms.small_buyer_id = '';
            that.Forms.company_id = '';
            that.Forms.pay_bank_account = '';
            that.Forms.pay_bank_real_name = '';
            that.Forms.pay_bank_name = '';
            that.Forms.pay_bank_address = '';
            that.buyerList = [];
            that.loadBuyerList();
        },
        /**
         * 功能：按当前维保记录加载已通过采购（编辑回显时保留已选）
         * time: 2026/10/06
         **/
        loadBuyerList(){
            let that = this;
            if(!that.Forms.maintain_id){
                that.buyerList = [];
                return;
            }
            getSmallBuyerSearchList({maintain_id: that.Forms.maintain_id}).then(e=>{
                that.buyerList = e.data ?? [];
            })
        },
        /**
         * 功能：选择采购后回填供应商及收款账户
         * time: 2026/10/06
         **/
        buyerChange(buyer_id){
            let that = this;
            if(!buyer_id){
                return;
            }
            let item = that.buyerList.find(v => parseInt(v.buyer_id) === parseInt(buyer_id));
            if(!item) return;
            if(item.company_id) that.Forms.company_id = parseInt(item.company_id);
            if(item.bank_account) that.Forms.pay_bank_account = item.bank_account;
            if(item.bank_real_name) that.Forms.pay_bank_real_name = item.bank_real_name;
            if(item.bank_name) that.Forms.pay_bank_name = item.bank_name;
            if(item.bank_address) that.Forms.pay_bank_address = item.bank_address;
            //含税金额为空时，默认带入合同金额
            if(that.Forms.true_money === '' && item.pay_money){
                that.Forms.true_money = item.pay_money;
            }
        },
        /**
         功能：附件删除
         time: 2026/09/12
         **/
        FileDelete(f){
            let that = this;
            that.Forms[f] = [];
        },
        /**
         功能：附件下载
         time: 2026/09/12
         **/
        FileDownload(url){
            let that = this;
            if(url){
                //下载文件
                const fileUrl = that.site_url + url; // 文件的URL地址
                const parts = fileUrl.split('/');
                const fileName = parts[parts.length - 1];
                const link = document.createElement('a');
                link.href = fileUrl;
                link.target = '_blank';
                link.setAttribute('download', fileName);
                link.click();
            }else{
                that.$Message.error({ background: true,duration:3, content: '没有资料可下载'});
            }
        },
        /**
         功能：上传成功
         time: 2026/09/12
         **/
        handleSuccess(res){
            let that = this;
            if(res.code === 100){
                this.Forms.image = [res.data.url];
            }else{
                that.$Message.error({ background: true,duration:3, content: res.msg});
            }
        },
        handleFormatError(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '只支持 jpg | png | pdf | doc | docx | xls | xlsx | rar | zip 文件' });
            return false;
        },
        handleMaxSize(){
            let that = this;
            that.$Message.error({ background: true,duration:3, content: '文件大小不能超出 50M' });
            return false;
        },
        /**
         功能：配置
         time: 2026/09/12
         **/
        GetConfig(){
            let that = this;
            getDispersedExpendConfig().then(e=>{
                that.typeList = e.data.typeList ?? [];
                that.companyList = e.data.companyList ?? [];
                that.projectList = e.data.projectList ?? [];
            })
        },
        /**
         功能：详情
         time: 2026/09/12
         **/
        GetDetail(expend_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getDispersedExpendDetail(expend_id).then(e => {
                let data = e.data;
                for (let v of Object.keys(that.Forms)) {
                    if(v === 'expend_id' || v === 'small_project_id' || v === 'maintain_id' || v === 'small_buyer_id' || v === 'type_id' || v === 'company_id') {
                        that.Forms[v] = data[v] !== '' && data[v] !== null && data[v] !== 0 ? parseInt(data[v]) : '';
                    }else if(v === 'image'){
                        that.Forms[v] = data[v] ? data[v] : [];
                    }else{
                        that.Forms[v] = data[v];
                    }
                }
                that.changeProject();
                //编辑回显：按维保记录加载采购选项（loadBuyerList 不清空已选）
                that.loadBuyerList();
            })
        },
        /**
         功能：添加
         time: 2026/09/12
         **/
        add(small_project_id){
            this.isBox = true;
            this.GetConfig();
            if(small_project_id){
                this.Forms.small_project_id = parseInt(small_project_id);
                this.is_select = true;
                this.changeProject();
            }
        },
        /**
         功能：编辑
         time: 2026/09/12
         **/
        edit(expend_id){
            this.isBox = true;
            this.is_select = true;
            this.GetConfig();
            if(expend_id) this.GetDetail(expend_id);
        },
        /**
         功能：提交
         time: 2026/09/12
         **/
        FormSubmit(){
            let that = this;
            this.$refs['Forms'].validate((valid) => {
                if (valid) {
                    that.$store.commit('SET_LOADING' , true);
                    saveDispersedExpend(that.Forms).then( e =>{
                        that.$Message.success({ background: true,duration:3, content: e.msg });
                        that.FormReset();
                        that.$emit('trueHandler');
                    })
                }
            })
        },
        /**
         功能：重置
         time: 2026/09/12
         **/
        FormReset(){
            this.isBox = false;
            this.title = '零星项目支出';
            this.$refs['Forms'].resetFields();
            this.Forms = {
                expend_id: '',
                small_project_id: '',
                maintain_id: '',
                small_buyer_id: '',
                type_id: '',
                company_id: '',
                money: '',
                tax_rate: '',
                tax_money: '',
                true_money: '',
                image: [],
                content: '',
                pay_bank_account: '',
                pay_bank_real_name: '',
                pay_bank_name: '',
                pay_bank_address: '',
                remark: ''
            };
            this.maintainList = [];
            this.buyerList = [];
            this.is_select = false;
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
